import { render, staticRenderFns } from "./page0.vue?vue&type=template&id=70d5a3fa&scoped=true"
import script from "./page0.vue?vue&type=script&lang=js"
export * from "./page0.vue?vue&type=script&lang=js"
import style0 from "./page0.vue?vue&type=style&index=0&id=70d5a3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5a3fa",
  null
  
)

export default component.exports